var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:'info-box uk-card uk-card-body ' +
        _vm.mode +
        (_vm.borderless ? ' borderless' : '') +
        (_vm.isRound ? ' round' : '') +
        (_vm.medium ? ' uk-padding-medium' : '') +
        (_vm.slim ? ' uk-padding-slim' : '')},[(_vm.closeable)?_c('a',{staticClass:"uk-alert-close",attrs:{"uk-close":""}}):_vm._e(),_c('div',{staticClass:"uk-grid-small",attrs:{"uk-grid":""}},[(_vm.icon)?_c('div',{staticClass:"uk-width-auto"},[_c('Icon',{staticClass:"icon",attrs:{"icon":_vm.icon,"ratio":1.5}})],1):_vm._e(),_c('div',{staticClass:"uk-width-expand"},[_vm._t("default")],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }